import { z } from 'zod';

const specifyDateSchema = z.object({
    nextSession: z.literal('Specify date'),
    date: z.string().optional(),
});

const nextWeekSchema = z.object({
    nextSession: z.literal('Next week'),
});

const clientWillReachOutSchema = z.object({
    nextSession: z.literal('Client will reach out to schedule'),
});

const noFurtherTreatmentSchema = z.object({
    nextSession: z.literal('No further treatment necessary'),
});

export const nextSessionSchema = z.discriminatedUnion('nextSession', [
    specifyDateSchema,
    nextWeekSchema,
    clientWillReachOutSchema,
    noFurtherTreatmentSchema,
]);

export const planSchema = z.object({
    nextSession: nextSessionSchema.optional(),
    homework: z.array(z.enum(["Client will practice skills from today's sessions"])).optional(),
    homeworkOther: z.string().trim().optional(),
    resourcesAndRecommendations: z.string().trim().optional(),
    followUpOn: z.string().trim().optional(),
});
